function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "icon-security_svg__a",
  d: "M0 0h100v100H0z"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("clipPath", {
  id: "icon-security_svg__b"
}, React.createElement("use", {
  xlinkHref: "#icon-security_svg__a",
  overflow: "visible"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M50.07 4H50c-9.97 10-40 18.1-40 18.1 0 31.87 2 59.9 40.04 73.98C88.08 82 90.08 53.98 90.08 22.1c0 0-30.03-8.1-40.01-18.1h0zm19.01 12.17l-39 69 39-69h0z",
  clipPath: "url(#icon-security_svg__b)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
});

function SvgIconSecurity(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 100 100"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIzLjAuNiwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkViZW5lXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAxMDAgMTAwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAxMDAgMTAwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+CgkKCQkuc3Qwe2NsaXAtcGF0aDp1cmwoI1NWR0lEXzJfKTtmaWxsOm5vbmU7c3Ryb2tlOiNGRkZGRkY7c3Ryb2tlLXdpZHRoOjI7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO30KPC9zdHlsZT4KPGc+Cgk8Zz4KCQk8ZGVmcz4KCQkJPHJlY3QgaWQ9IlNWR0lEXzFfIiB4PSIwIiB5PSIwIiB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIvPgoJCTwvZGVmcz4KCQk8Y2xpcFBhdGggaWQ9IlNWR0lEXzJfIj4KCQkJPHVzZSB4bGluazpocmVmPSIjU1ZHSURfMV8iICBzdHlsZT0ib3ZlcmZsb3c6dmlzaWJsZTsiLz4KCQk8L2NsaXBQYXRoPgoJCTxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik01MC4wNyw0aC0wLjA3QzQwLjAzLDE0LDEwLDIyLjEsMTAsMjIuMWMwLDMxLjg3LDIsNTkuOSw0MC4wNCw3My45OEM4OC4wOCw4Miw5MC4wOCw1My45OCw5MC4wOCwyMi4xCgkJCUM5MC4wOCwyMi4xLDYwLjA1LDE0LDUwLjA3LDRMNTAuMDcsNHogTTY5LjA4LDE2LjE3bC0zOSw2OUw2OS4wOCwxNi4xN0w2OS4wOCwxNi4xN3oiLz4KCTwvZz4KPC9nPgo8L3N2Zz4K";
export { SvgIconSecurity as ReactComponent };